import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
import areaSelect from 'area-select';
import payTypeInfo from '@pages/Order/MeetOrder/components/payTypes/index.vue'; //支付方式
import AddressDialog from "@pages/Order/MeetOrder/components/AddressDialog/index.vue" // 选择收货地址弹窗
import schoolList from "src/common/components/schoolList/index.vue" //园所弹窗
import babyDialog from "../babyList/index.vue" //下单宝贝列表
import parentDialog from "../parentList/index.vue" //下单家长列表
import validate from 'validate';
export default {
  mixins: [services],
  components: {
    'area-select': areaSelect,
    payTypeInfo,
    AddressDialog,
    schoolList,
    babyDialog,
    parentDialog

  },
  props: {
    value: {
      type: Object,
      default: null
    },
    hideShowArea: {
      default: false
    },
    myIndex: {
      default: 1
    },
    total: {
      default: 1
    },
    isReadOnly: {
      default: false
    },
    OrderSouce: {
      default: 0
    },
    packageId: {
      type: Number,
      default: 10002
    }

  },
  watch: {
    value: {
      deep: true,
      handler: function(val) {
        this.setValue();
      }
    },
  },
  data() {
    return {
      form: this.getFormData(), //提交字段
      info: this.getData(), //不需要提交的字段
      ConsigneeData: this.getConsigneeData(),
      schoolList: [], //园所列表
      classList: [], //班级列表
      payList: [{}],
      isDelShow: [false],
      RefereeData: this.getReferee(),


    }
  },
  methods: {

    getFormData() {
      return cloneDeep({
        "BabyType": '', //0是有园，1是无园
        "BabyId": 0,
        "ParentId": 0,
        "SchoolId": 0,
        "NetInfo": {
          "NetworkOperator": [],
          "NetworkType": [],
          "Distance": "",
          "Engineer": ""
        },
        "ReceiptInfo": {
          "ConsigneeId": ""
        },
        "PayList": [{
          "PayWay": 0,
          "Trade_No": "",
          "BankName": "",
          "VoucherPic": "",
          "OrderActualPrice": 0,
          "PayRemark": ""
        }],
        "DiscountType": 1 //1：家长订购价 10：内部价
      });
    },
    getData() {
      // 宝贝信息
      return cloneDeep({
        AgentId: '',
        ClassId: '',
        babyName: '',
        babySex: '',
        babyDath: '',
        parentName: '',
        parentTel: '',
        parentNick: '',
        ConsigneeList: '', //收货地址
        AgentName: '', //代理商
        SchoolName: '', //园所
      })
    },
    changeBabyType(val) {
      if (this.value == null) {
        this.info = this.getData()

      }
    },
    // 转介绍信息
    getReferee() {
      return cloneDeep({
        RefereeBabyId: '',
        RefereeParentId: ''
      })
    },
    getConsigneeData() {
      return cloneDeep({
        Consignee: '',
        ConsigneeTel: '',
        ConsigneeArea: '',
        ConsigneeAdress: ''
      });
    },
    initData() {
      this.form = this.getFormData()
      this.info = this.getData()
      this.ConsigneeData = this.getConsigneeData()
      this.payList = [{}]
    },
    setValue() {

      if (this.value !== null) {
        this.$nextTick(() => {
          let infoData = cloneDeep(this.value)
          if (infoData.RefereeBabyInfoData) {
            // 转介绍人信息
            //RefereeBabyInfoData
            this.info.babyName = infoData.RefereeBabyInfoData.BabyName
            this.info.babySex = infoData.RefereeBabyInfoData.Sex
            this.info.babyDath = infoData.RefereeBabyInfoData.Birthday
              // this.info.parentName = infoData.RefereeParentInfoData.UserName
              // this.info.parentTel = infoData.RefereeParentInfoData.PhoneNo
              // this.info.parentNick = infoData.RefereeParentInfoData.ParentNick
            if (infoData.RefereeAgentInfoData !== undefined) {
              this.form.BabyType = 0
              this.info.AgentName = infoData.RefereeAgentInfoData.AgentNameC_Name + infoData.RefereeAgentInfoData.C_Tel
              this.info.SchoolName = infoData.RefereeSchoolInfoData.SchoolName
              this.form.SchoolId = infoData.RefereeSchoolInfoData.SchoolId
              this.GetClassList(this.form.SchoolId)
              this.info.ClassId = infoData.RefereeClassInfoData.ClassId
            } else {
              // this.info.AgentName = '非正式合作代理商'
              // this.info.SchoolName = '非正式合作园所'
              this.form.BabyType = 1
            }
          } else {
            this.form.DiscountType=infoData.DiscountType
            if (infoData.AgentInfo !== undefined) {
              this.info.AgentName = infoData.AgentInfo.AgentNameC_Name + ' ' + infoData.AgentInfo.C_Tel
              this.info.SchoolName = infoData.SchoolInfo.SchoolName
              this.form.SchoolId = infoData.SchoolInfo.SchoolId
              this.GetClassList(this.form.SchoolId)
              this.info.ClassId = infoData.ClassInfo.ClassId
            }
            this.packageId = infoData.PackageId
            if (infoData.PackageId == 10002) {
              this.form.NetInfo.NetworkOperator = infoData.NetInfo.NetworkOperators
              this.form.NetInfo.NetworkType = infoData.NetInfo.NetworkTypes
              this.form.NetInfo.Distance = infoData.NetInfo.Distance
              this.form.NetInfo.Engineer = infoData.NetInfo.Engineer
            }
            this.form.BabyType = infoData.BabyType
            this.info.babyName = infoData.BabyInfo.BabyName
            this.info.babySex = infoData.BabyInfo.Sex
            this.info.babyDath = infoData.BabyInfo.Birthday
            this.info.parentName = infoData.ParentName
            this.info.parentTel = infoData.UserTel
            this.form.ParentId = infoData.UserId
            this.info.parentNick = infoData.ParentNick

            this.form.ReceiptInfo.ConsigneeId = infoData.ConsigneeList[0].ConsigneeId
            this.ConsigneeData.Consignee = infoData.ConsigneeList[0].Consignee
            this.ConsigneeData.ConsigneeTel = infoData.ConsigneeList[0].ConsigneeTel
            this.ConsigneeData.ConsigneeArea = infoData.ConsigneeList[0].ConsigneeProvName + '-' + infoData.ConsigneeList[0].ConsigneeCityName + '-' + infoData.ConsigneeList[0].ConsigneeAreaName
            this.ConsigneeData.ConsigneeAdress = infoData.ConsigneeList[0].ConsigneeAddress
            this.payList = infoData.OrderPayInfo
          }



        })

      }

    },
    // 选择代理商
    chooseAgent() {
      this.$refs.schoolList.show({
        title: '选择代理商',
        isCommon: true
      });
    },
    //选择园所
    chooseSchool() {
      this.$refs.schoolList.show({
        title: '选择园所',
      });

    },
    // 获取园所组件chooseDialog 值
    getDialogList(item) {
      this.info.SchoolName = item.SchoolName;
      this.info.ClassId = ''; //初始化班级
      this.form.SchoolId = item.Id;
      this.GetClassList(this.form.SchoolId); //获取班级列表
      this.info.AgentName = item.AgentCustomerName + ' ' + item.C_name + ' ' + item.C_Tel;
      this.info.AgentId = item.CustomerId;
    },
    //选择园所收货地址
    changeAddress() {
      if (this.form.ParentId == 0) {
        this.$notify({
          title: '警告',
          message: '请先选择' + this.textTitle + '家长',
          type: 'warning'
        });
      } else {
        this.$refs.AddressDialog.show({
          ParentId: this.form.ParentId,
          ParentName: this.info.parentName,
          ParentPhoneNo: this.info.parentTel
        });
      }

    },

    // 选择下单宝贝
    chooseBaby() {
      if (this.form.BabyType === 0) {
        // 正式合作宝贝
        if (this.info.SchoolName == '') {
          this.$notify({
            title: '警告',
            message: '请先选择园所',
            type: 'warning'
          });
        } else if (this.info.ClassId == 0) {
          this.$notify({
            title: '警告',
            message: '请先选择班级',
            type: 'warning'
          });
        } else {
          if (this.hideShowArea) {
            // 转介绍
            this.$refs.babyDialog.show({
              title: "选择转介绍宝贝",
              ClassId: this.info.ClassId,
              OrderSource: 3
            });
          } else {
            this.$refs.babyDialog.show({
              title: "选择下单宝贝",
              ClassId: this.info.ClassId,
              PackageId: this.packageId
            });
          }
        }
      } else if (this.form.BabyType == 1) {
        // 非正式合作宝贝
        if (this.hideShowArea) {
          // 转介绍
          this.$refs.babyDialog.show({
            title: "选择转介绍宝贝",
            OrderSource: 3,
          });
        } else {
          this.$refs.babyDialog.show({
            title: "选择下单宝贝",
            PackageId: this.packageId
          });
        }
      } else {
        this.$notify({
          title: '警告',
          message: '请先选择' + this.textTitle + '宝贝类型',
          type: 'warning'
        });
      }


    },
    // 选择下单家长
    chooseParent() {
      if (this.form.BabyId == 0) {
        this.$notify({
          title: '警告',
          message: '请先选择' + this.textTitle + '宝贝2',
          type: 'warning'
        });
      } else {
        this.$refs.parentDialog.show({
          title: "选择下单家长",
          BabyId: this.form.BabyId
        });
      }
    },
    // chooseNoSchoolBaby() {
    //     let title = '选择下单家长'
    //     if (this.hideShowArea) {
    //         // 转介绍
    //         this.$refs.babyDialog.show({
    //             title: "选择宝贝",
    //             OrderSource: 3
    //         });
    //     } else {
    //         this.$refs.babyDialog.show({
    //             title: "选择下单家长",
    //         });
    //     }
    // },
    // 获取下单宝贝信息
    getBabyInfo(item) {
      // 家长信息清空
      this.form.ParentId = ''
      this.info.parentName = ''
      this.info.parentTel = ''
      this.info.parentNick = ''
      this.ConsigneeData = this.getConsigneeData()
      if (this.hideShowArea) {
        // 转介绍
        this.RefereeData.RefereeBabyId = item.BabyId
        this.RefereeData.RefereeParentId = item.ParentId

      } else {
        this.form.BabyId = item.BabyId
      }
      if (item.ClassId == 0) {
        // 非正式合作宝贝
        this.info.AgentName = '非正式合作代理商'
        this.info.SchoolName = '非正式合作园所'
      }
      this.info.babyName = item.BabyName
      this.info.babySex = item.Sex
      this.info.babyDath = item.Birthday

    },
    // 获取下单家长信息
    getParentInfo(item) {
      console.log(item)
      this.form.ParentId = item.ParentId
      this.info.parentName = item.ParentName
      this.info.parentTel = item.ParentPhoneNo
      this.info.parentNick = item.ParentNick
      this.GetBabyConsigneeList(this.form.ParentId)
    },
    //获取选择弹窗收货地址
    getAddress(item) {
      console.log(item)
      this.info.ConsigneeList = item.ConsigneeProvinceName + '  ' + item.ConsigneeCityName + '  ' + item.ConsigneeAreaName + '  ' + item.ConsigneeAdress
      this.form.ReceiptInfo.ConsigneeId = item.Id
      this.ConsigneeData.Consignee = item.Consignee
      this.ConsigneeData.ConsigneeTel = item.ConsigneeTel
      this.ConsigneeData.ConsigneeArea = item.ConsigneeProvinceName + ' - ' + item.ConsigneeCityName + ' - ' + item.ConsigneeAreaName
      this.ConsigneeData.ConsigneeAdress = item.ConsigneeAdress
    },
    addFn() {
      this.payList.push({})
      this.isDelShow.push(true)
    },
    delPayFn(item) {
      this.payList.splice((item.index - 1), 1);

    },
    validate() {

      // if (this.hideShowArea) {
      // console.log(this.RefereeData)
      //         return this.RefereeData
      //         
      //     }
      let commonText = ''
      if (this.total > 1 && this.OrderSouce == 4) {
        commonText = '订单' + this.myIndex
      }
      let checkRules = [{
        name: this.textTitle + "宝贝类型",
        value: this.form.BabyType,
        required: true,
        msg: "请选择" + commonText + this.textTitle + "宝贝类型"
      }]
      if (this.form.BabyType == 0) {
        if (this.info.ClassId == 0) {
          this.info.ClassId = ''
        }
        checkRules.push({
          name: "所属园所",
          value: this.info.SchoolName,
          required: true,
          msg: "请选择" + commonText + this.textTitle + "所属园所"
        }, {
          name: "班级",
          value: this.info.ClassId,
          required: true,
          msg: "请选择" + commonText + this.textTitle + "班级"
        }, )
      }
      checkRules.push({
        name: this.textTitle + "宝贝",
        value: this.info.babyName,
        required: true,
        msg: "请选择" + commonText + this.textTitle + "宝贝"
      })
      if (!this.hideShowArea) {
        // 非转介绍信息判断
        if (this.form.NetInfo.Distance == 0) {
          this.form.NetInfo.Distance = ''
        }
        if (this.packageId == 10002) {
          checkRules.push({
            name: this.textTitle + "家长",
            value: this.info.parentName,
            required: true,
            msg: "请选择" + commonText + this.textTitle + "家长"
          }, {
            name: "家庭网络运营商",
            value: this.form.NetInfo.NetworkOperator,
            required: true,
            msg: "请选择" + commonText + "家庭网络运营商"
          }, {
            name: "家庭网络情况",
            value: this.form.NetInfo.NetworkType,
            required: true,
            msg: "请选择" + commonText + "家庭网络情况"
          }, {
            name: "电视到宽带口距离",
            value: this.form.NetInfo.Distance,
            required: this.isShowD,
            msg: "请选择" + commonText + "电视到宽带口距离"
          }, {
            name: "是否需要上门服务",
            value: this.form.NetInfo.Engineer,
            required: true,
            msg: "请选择" + commonText + "是否需要上门服务"
          }, {
            name: "收货地址",
            value: this.form.ReceiptInfo.ConsigneeId,
            required: true,
            msg: '请选择' + commonText + '收货地址'
          })
        } else {
          checkRules.push({
            name: this.textTitle + "家长",
            value: this.info.parentName,
            required: true,
            msg: "请选择" + commonText + this.textTitle + "家长"
          }, {
            name: "收货地址",
            value: this.form.ReceiptInfo.ConsigneeId,
            required: true,
            msg: '请选择' + commonText + '收货地址'
          })
        }

      }
      var flag = util.checkForm({
        ele: this,
        rules: checkRules
      });
      if (!flag) {
        return false;
      } else if (this.hideShowArea) {
        return this.RefereeData
      } else {
        this.form.PayList = []
        for (let i = 0; i < this.payList.length; i++) {
          let data = this.$refs['payInfo' + (i + 1)][0].validate();
          if (!data) {
            if (commonText !== '') {
              this.$notify({
                title: '警告',
                message: "请完善" + commonText + '支付信息',
                type: 'warning'
              });
            }
            return;
          }
          this.form.PayList.push(data);
        }
        return this.form;

      }
    }
  },
  created() {
    if (this.value !== null) {
      this.setValue();
    }
  },
  computed: {
    isShowD() {
      if (this.form.NetInfo.NetworkType.indexOf(2) > -1) {
        return true
      } else {
        return false
      }
    },
    textTitle() {
      if (this.hideShowArea) {
        // 转介绍
        return '转介绍'
      } else {
        return '下单'
      }
    },
    price() {
      if (this.form.DiscountType == 1) {
        return 4699
      } else {
        return 3999
      }
    }

  }
}


// WEBPACK FOOTER //
// ./src/pages/Order/LBHomeOrder/components/orderDetails/vm.js